import { HttpInterceptorFn, HttpHandlerFn, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AppStorageService } from '../services/app-storage.service';
import { StorageKeys } from '../services/storage-keys';

/**
 * Functional HTTP interceptor that:
 * 1. Adds Bearer token from localStorage (if authenticated and not guest)
 * 2. Adds Accept-Language header from stored language
 * 3. Handles 401 (clears session) and 403 errors
 */
export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const storage = inject(AppStorageService);
  let headers = req.headers;

  // Add Authorization if token exists and user is not guest
  const token = storage.get(StorageKeys.TOKEN);
  const guest = storage.get(StorageKeys.GUEST);

  if (token && guest !== 'true' && !headers.has('Authorization')) {
    headers = headers.set('Authorization', `Bearer ${token}`);
  }

  const clonedReq = req.clone({ headers });

  return next(clonedReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        storage.set(StorageKeys.GUEST, 'true');
        storage.remove(StorageKeys.USER);
        storage.remove(StorageKeys.TOKEN);
      }
      return throwError(() => error);
    })
  );
};
